export enum AdjustmentNoteCategoryEnum {
    DEBIT = 'DEBIT' ,
    CREDIT = 'CREDIT'
}